import { render, staticRenderFns } from "./IncidentCategoryDialog.vue?vue&type=template&id=cdc752fa&scoped=true&"
import script from "./IncidentCategoryDialog.vue?vue&type=script&lang=js&"
export * from "./IncidentCategoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc752fa",
  null
  
)

export default component.exports